//import Moment from "moment";

const getCount = (state) => {
	return state.marcas.length;
}

export default {
	getCount
}